import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Checkbox, FormControlLabel } from '@mui/material';
import { Translation } from 'react-i18next';
import DigestDeliverySelector from './digest-delivery-selector';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChallengeDigestSettings = function ChallengeDigestSettings(_ref) {
  var preferences = _ref.preferences,
      setPreferences = _ref.setPreferences,
      disabled = _ref.disabled,
      digestDeliveryOptions = _ref.digestDeliveryOptions,
      setDirty = _ref.setDirty,
      unsubscribed = _ref.unsubscribed;
  return digestDeliveryOptions.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsx(FormControlLabel, {
          control: /*#__PURE__*/_jsx(Checkbox, {
            name: 'challengeDigest',
            checked: !unsubscribed && preferences.challengeDigest,
            disabled: disabled,
            onChange: function onChange(e) {
              setDirty();
              setPreferences(_objectSpread(_objectSpread({}, preferences), {}, _defineProperty({}, e.target.name, e.target.checked), e.target.checked ? {
                unsubscribedFromAllEmails: false
              } : {}));
            }
          }),
          label: t('Challenge Digest')
        });
      }
    }), preferences.challengeDigest && /*#__PURE__*/_jsx(DigestDeliverySelector, {
      preferences: preferences,
      setPreferences: setPreferences,
      disabled: disabled,
      digestDeliveryOptions: digestDeliveryOptions,
      setDirty: setDirty
    })]
  }) : null;
};

export default ChallengeDigestSettings;